import React from 'react';
import { Card, CardBody, CardTitle, Col, Container, Row } from 'reactstrap';
import Breadcrumb from 'Components/Common/Breadcrumb';
import Detail from './Detail';

const SettingsMenuIndex = () => {
  document.title = "Меню";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Системийн удирдлага" breadcrumbItem="Меню" />
          <Row>
            <Detail/>
          </Row>
        </Container>
      </div>
    </React.Fragment >
  );
}

export default SettingsMenuIndex;